export default __webpack_public_path__ + "static/media/08-ART-(2-4).b2adca60.jpg";